// ...existing code removed; gatsby-plugin-emotion is used automatically...

import React from 'react';
import { ThemeProvider } from './src/components/ThemeContext';
import ThemeToggle from './src/components/ThemeToggle';

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    {element}
    <ThemeToggle />
  </ThemeProvider>
);

/**
 * Control scroll behavior for Gatsby Link navigation
 * Return [0, 0] to force scroll position to top
 */
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // If there's a hash (anchor link), allow default behavior
  if (location.hash) {
    return true;
  }
  
  // Return [x, y] coordinates to force scroll position
  return [0, 0];
};
